import { getMessage } from "../../../marketplace-next/src/libs/intl/getMessage";
export var solveMessage = function (message, _a) {
    var businessUnit = _a.businessUnit, country = _a.country, _b = _a.messages, messages = _b === void 0 ? {} : _b;
    var businessUnitCode = businessUnit ? businessUnit + "-" + country : "";
    return messages && messages[message]
        ? messages[message]
        : getMessage(message, { businessUnitCode: businessUnitCode });
};
//# sourceMappingURL=solveMessage.js.map